export default __webpack_public_path__ + "static/media/elec-7.e46daeb8.png";